const galleryLinks = require('./config/gallery.json')

export default galleryLinks
